import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { 
  PhoneIcon,
  UserIcon,
  MapPinIcon,
  HeartIcon
} from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { toast } from "sonner";
import { openWhatsApp } from "../lib/utils";

const HeroSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    city: "",
    disease: ""
  });

  // Static data for cities and diseases
  const cities = [
    "Faridabad", "Delhi", "Gurgaon", "Noida"
  ];

  const diseases = [
    // Diseases with existing pages
    "Piles", "Hernia", "Gall stones", "Kidney stone", "Circumcision",
    // Eye treatments with existing pages
    "Cataract Surgery", "LASIK Eye Surgery", "Femto LASIK Surgery", "SMILE LASIK Surgery",
    "Glaucoma Surgery", "Diabetic Retinopathy", "Retinal Detachment", "ICL Surgery", 
    "Vitrectomy Surgery", "PRK LASIK Surgery", "Contoura Vision", "Phaco Surgery", "Squint Surgery"
  ];

  const handleBooking = () => {
    if (!formData.name || !formData.mobile || !formData.city || !formData.disease) {
      toast.error("Please fill all required fields");
      return;
    }
    toast.success("Free consultation booked successfully! Our team will contact you soon.");
    setFormData({ name: "", mobile: "", city: "", disease: "" });
  };

  return (
    <section className="relative overflow-hidden py-6 sm:py-8 md:py-12 lg:py-16">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video 
          src="/videos/herosection_bg.mp4" 
          autoPlay 
          loop 
          muted 
          playsInline
          className="w-full h-full object-cover"
        />
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center">
          {/* Left Side - Content */}
          <div className="space-y-6 sm:space-y-8">
            <div>
              <h1 className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                TheLivCure
                <span className="block text-blue-600">Empowering healthier lives</span>
              </h1>
            </div>

            {/* Statistics - temporarily disabled per content policy */}
            {false && (
            <div className="grid grid-cols-3 gap-2 xs:gap-3 sm:gap-6">
              <div className="text-center">
                <div className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">400 +</div>
                <div className="text-xs sm:text-sm text-gray-600">DOCTORS</div>
              </div>
              <div className="text-center">
                <div className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">50 +</div>
                <div className="text-xs sm:text-sm text-gray-600">DISEASES</div>
              </div>
              <div className="text-center">
                <div className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">30 +</div>
                <div className="text-xs sm:text-sm text-gray-600">CITIES</div>
              </div>
            </div>
            )}

            <Button 
              size="lg" 
              className="bg-gray-900 hover:bg-gray-600 text-white font-semibold px-4 sm:px-6 lg:px-8 py-3 sm:py-3 text-sm sm:text-base w-full sm:w-auto min-h-[48px]"
              onClick={() => openWhatsApp("+917042137561", "Hi, I am contacting you for treatment from TheLivCure site.")}
            >
              <PhoneIcon className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
              <span className="hidden xs:inline">Call Us: +91 93117 20045</span>
              <span className="xs:hidden">Call Now</span>
            </Button>

            <div className="space-y-3 sm:space-y-4">
              <h3 className="text-base sm:text-lg font-semibold text-white">
                Book Appointments With Our Expert Doctors Near You
              </h3>
            </div>
          </div>

          {/* Right Side - Booking Form & Doctor Image */}
          <div className="relative order-first lg:order-last">
            {/* Doctor Image - Responsive visibility */}
            {/* <div className="relative mb-4 sm:mb-6 lg:mb-8 rounded-2xl sm:rounded-3xl overflow-hidden  hidden md:block">
              <img src="/image/homeImage.png" className="rounded-xl" alt="doctor" />
              {/* <div className="bg-gradient-to-br from-white to-gray-100 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 flex justify-center">
                <div className="w-40 h-48 sm:w-48 sm:h-60 md:w-56 md:h-72 lg:w-64 lg:h-80 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-xl sm:rounded-2xl flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full mx-auto mb-2 sm:mb-3 md:mb-4 flex items-center justify-center">
                      <UserIcon className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-16 lg:h-16 text-white" />
                    </div>
                    <div className="text-xs sm:text-sm text-gray-600 bg-white px-2 sm:px-3 md:px-4 py-1 sm:py-2 rounded-full">
                      Expert Doctor
                    </div>
                  </div>
                </div>
              </div> */}
            {/* </div> */}

            {/* Booking Form */}
            <Card className="bg-white shadow-xl border-0">
              <CardHeader className="pb-3 sm:pb-4">
                <CardTitle className="text-lg sm:text-xl font-bold text-center text-gray-900">
                  Book Free Consultation
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3 sm:space-y-4">
                <Input
                  placeholder="Patient Name"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="text-sm sm:text-base"
                />
                
                <Input
                  placeholder="Mobile Number"
                  value={formData.mobile}
                  onChange={(e) => setFormData({...formData, mobile: e.target.value})}
                  className="text-sm sm:text-base"
                />
                
                <Select 
                  value={formData.city} 
                  onValueChange={(value) => setFormData({...formData, city: value})}
                >
                  <SelectTrigger className="text-sm sm:text-base">
                    <SelectValue placeholder="Select City" />
                  </SelectTrigger>
                  <SelectContent>
                    {cities.map((city) => (
                      <SelectItem key={city} value={city}>
                        {city}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                
                <Select 
                  value={formData.disease} 
                  onValueChange={(value) => setFormData({...formData, disease: value})}
                >
                  <SelectTrigger className="text-sm sm:text-base">
                    <SelectValue placeholder="Select Disease" />
                  </SelectTrigger>
                  <SelectContent>
                    {diseases.map((disease) => (
                      <SelectItem key={disease} value={disease}>
                        {disease}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                
                <Button 
                  onClick={handleBooking}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 sm:py-3 text-sm sm:text-base"
                >
                  Book Now
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;